import Form, { FormProps } from '..';
import BannerBatch from './BannerBatch';
import BannerDescription from './BannerDescription';
import BannerPost from './BannerPost';
import BannerPreview from './BannerPreview';
import BannerPrice from './BannerPrice';

export interface FormBannerProps extends FormProps {}

const FormBanner = ({
  children,
  className = '',
  title,
  ...rest
}: FormBannerProps) => {
  return (
    <Form className={`form-banner ${className}`} {...rest}>
      {title && <header className={'form-banner-header'}>{title}</header>}
      <div className={'form-banner-body'}>{children}</div>
    </Form>
  );
};
export default Object.assign(FormBanner, {
  Post: BannerPost,
  Description: BannerDescription,
  Price: BannerPrice,
  Batch: BannerBatch,
  Preview: BannerPreview,
});
